import { Family, GenericIdName, DigitalFormDataVM, DigitalFormQuestionsCategoriesVM, DigitalFormQuestionsVM, DigitalFormVM, DigitalFormQuestionTypesVM, UpdateCustomerVM, GenericIdName_,AddQuestionVM, FormHeaderVM, ImplementLoadVM } from '../models/digitalForm.model';
import { Component, OnInit, Inject } from '@angular/core';
import { CustomerOverview } from '../models/customer.model';
import { AppService } from '../../../app.service';
import { UserServiceIdentity } from '../services/user.service';
import { DigitalFormServiceIdentity } from '../services/digital-form.service';
import { MatDialog } from '@angular/material/dialog';import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { CustomerServiceIdentity } from '../services/customer.service';
import { AddFormcategoryComponent } from '../create-digital-form/components/add-formcategory/add-formcategory.component';
import { ConfirmDialogComponentIdentity } from '../create-digital-form/components/confirm-dialog/confirm-dialog.component';
import { JobsiteSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';

@Component({
  selector: 'app-edit-digital-form',
  templateUrl: './edit-digital-form.component.html',
  styleUrls: ['./edit-digital-form.component.scss']
})
export class EditDigitalFormComponent implements OnInit {
  applytoMachines:boolean =true;
  emailOnclomplete:boolean;
  startbyInspector:boolean = false;
  startbySupervisor:boolean = false;
  FECRForm:boolean;
  formName:string;
  selectedFamilies:Family;
  familyList:Family[] = [];
  familyId:number[] = [];
  customerId:number[] = [];
  JobsiteId:number[] = [];
  modelId:number[] = [];
  modelList: GenericIdName[] = [];
  FormCatList: GenericIdName[] = [];
  customerList: CustomerOverview[];
  FormcatId:number;
  formId:number=0;
  showModelList:boolean=false;
  isFormCategorySelect:boolean=false;
  DigtalFormOverview:DigitalFormDataVM;
  formQSections : DigitalFormQuestionsCategoriesVM[]=[];
  formQCategories : DigitalFormQuestionsCategoriesVM[]=[];
  formQuestions : DigitalFormQuestionsVM[]=[];
  form :DigitalFormVM;
  questionTypes:DigitalFormQuestionTypesVM[]=[];
  loading:boolean=true;
  header_Date:boolean;
  header_Rivision:boolean;
  header_Username:boolean;
  header_CusJob:boolean;
  header_Unit:boolean;
  header_Smu:boolean;
  header_WorkOrder:boolean;
  showFECRTypes:boolean=false;
  fecrInspectionTypeId:number;
  FECRInspectionTypes:GenericIdName[]=[];
  ImplementTemplateList:GenericIdName[];
  jobsiteList:GenericIdName_[];
  familyFilteredList:GenericIdName_[];
  headerFormList:FormHeaderVM[];

  constructor(private _appService: AppService, private _userService: UserServiceIdentity,
    private _formService:DigitalFormServiceIdentity,private _customerService:CustomerServiceIdentity,
    public dialog: MatDialog, private _dialog: MatDialog,
    private _route: ActivatedRoute, private _router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private _notification: NotificationsService, private _favouriteDialogService:FavouriteDialogService) { }

  ngOnInit() {
    this._appService.setPageTitle('Edit Digital Form');
    this.formId = +this._route.snapshot.paramMap.get('id');
    this.loadCustomerList();
    this.loadFormCatList();
    this.loadFamilyList();
    this.loadFECRInspectionTypes();
  }

  loadCustomerList(){
    this._customerService.getAllCustomers().subscribe(response => {
      this.customerList = response;
      //console.log("this.customerList", this.customerList)
      if(this.formId>0){
        this.GetDigitalFormDetails()
      }
    });
  }

  loadFamilyList() {
    this._formService.getFamilyListData().subscribe(result => {
      this.familyList = result
      //console.log("this.familyList", this.familyList)
    })
  }

  loadFormCatList() {
    this._formService.getFormCategoryList().subscribe(result => {
      this.FormCatList = result;
      //console.log("this.FormCatList", this.FormCatList)
    })
  }

  loadFECRInspectionTypes(){
    this._formService.getFECRInspectionTypes().subscribe(result=>{
      this.FECRInspectionTypes = result;
    })
  }

  GetDigitalFormDetails(){
    this._formService.GetDigitalFormDetails(this.formId).subscribe(res=>{
      this.DigtalFormOverview = res;
      this.form = this.DigtalFormOverview.DigitalForms;
      this.formName = this.form.FormName;
      this.emailOnclomplete = this.form.EmailonComplete;
      this.startbyInspector=this.form.StartByInspector;
      this.startbySupervisor = this.form.StartBySupervisor;
      this.FormcatId = this.form.FormCategoeryId;
      this.customerId = this.form.customerId;
      this.familyId = this.form.familyId;
      this.modelId = this.form.modelId;
      this.FECRForm=this.form.FECRForm;
      this.ImpTemplateId = this.form.FormLinkedTemplateId;
      this.JobsiteId=this.form.jobsiteId;

      if(this.customerId != null && this.customerId.length>0){
        this.loadJobsitesForCustomer();
      }
       if(this.customerId != null && this.customerId.length>0){
        this.loadFamiliesForCustomer();
      }

      if(this.modelId != null && this.customerId != null && this.modelId.length>0 && this.customerId.length>0 ){
        this.LoadImplementTemplateList();
      }
     
if(this.FECRForm==true){
  this.showFECRTypes =true;
  this.fecrInspectionTypeId = this.form.FECRInspectionType;
}else{
  //this.showFECRTypes=false;
}
//console.log("data___11", this.showFECRTypes,this.FECRForm )
if((this.showFECRTypes==true && !this.FECRForm) || (this.showFECRTypes==false && this.FECRForm)){

  this._formService.UpdateFECRForm(this.formId).subscribe(res=>{
    if(res>0){}
   // this._notification.success('Updated','Update the Form')
  else
    this._notification.error('Failed','Failed to update the Form')
  
  })
}
    
     
if( this.familyId!=null && this.familyId.length>0){
  this.loadModelList();
}
      if( this.modelId!=null){
        this.applytoMachines =true;
        this.showModelList=true;
      }
      this.formQCategories=this.DigtalFormOverview.ParentCategories;
      this.formQSections=this.DigtalFormOverview.CategorySections;
      this.formQuestions=this.DigtalFormOverview.Questions;
      this.questionTypes=this.DigtalFormOverview.QuestionTypes;
      //console.log("DigtalFormOverview__", this.DigtalFormOverview,this.formQCategories, this.formQSections)
      this.GetFormHeader();
      this.loading=false;
    })
  }

  GetFormHeader(){
    this._formService.GetDigitalFormHeaderFields(this.formId).subscribe(res=>{
      //console.log("headerinfo", res);
      this.headerFormList= res;

      this.formQuestions.map(q=>{
        let check =  this.headerFormList.find(y=>y.qid == q.QuestionId);
        if(check){
          q.isIncludeHeader=true;
        }else{
          q.isIncludeHeader=false;
        }
      })
      this.header_Username=false;
      this.header_CusJob=false;
      this.header_Date=false;
      this.header_Rivision=false;
      this.header_Unit=false;
      this.header_Smu=false;
      this.header_WorkOrder=false;
      this.headerFormList.map(x=>{
        if(x.standardField == 1)
          this.header_Username=true;
        if(x.standardField == 2)
          this.header_Rivision=true;
        if(x.standardField == 3)
          this.header_Date=true;
        if(x.standardField == 4)
          this.header_CusJob=true;
        if(x.standardField == 5)
          this.header_Unit=true;
        if(x.standardField == 6)
          this.header_Smu=true;
        if(x.standardField == 7)
          this.header_WorkOrder=true;
      })
    })
  }

  loadFamiliesForCustomer(){
        var params: JobsiteSelectionFilter = {
          Customers: this.customerId,
        }
          this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
            if (r) {
              this.familyFilteredList = r;
              console.log("familyFilteredList", this.familyFilteredList)
            }
          });
      }

  ChangeHeader(standardId:number,event:any){
    let check = this.headerFormList.find(x=>x.standardField==standardId);
    if(check){
       this._formService.UpdateFormHeader(standardId,0,this.formId).subscribe(res=>{
         if(res)
         this.GetFormHeader();
       })
    }else{
      if(this.headerFormList.length<8){
       this._formService.UpdateFormHeader(standardId,0,this.formId).subscribe(res=>{
         if(res)
         this.GetFormHeader();
       })
      }else{
        alert("Form header can only include 7 fields. You will need to remove a field from the header before you can add another") 
        this.GetFormHeader()
      }
    }
     
   }
   toggleIncludeFormHeader(QId:number){
     let check = this.headerFormList.find(x=>x.qid==QId);
    if(check){
       this._formService.UpdateFormHeader(0,QId, this.formId).subscribe(res=>{
         if(res)
         this.GetFormHeader();
       })
    }else{
      if(this.headerFormList.length<8){
       this._formService.UpdateFormHeader(0,QId,this.formId).subscribe(res=>{
         if(res)
         this.GetFormHeader();
       })
      }else{
        alert("Form header can only include 7 fields. You will need to remove a field from the header before you can add another")
        
        this.GetFormHeader()
      }
    }
   }
  FormCatSelect(){
    if(this.FormcatId>0){
      this.isFormCategorySelect =true;
      let catName = this.FormCatList.find(x=>x.Id==this.FormcatId).Name;
      if(catName=='Frame Undercarriage Rebuild Centre'){
        this.showFECRTypes=true;
        
      }else{
        this.showFECRTypes=false;
      }
    }
    if(this.formId==0){
      //create new Form
      this._formService.CreateDigitalForm(this.FormcatId).subscribe(res=>{
        this.formId = res;
        this.GetDigitalFormDetails();
      })
    }else{
      //console.log("formId", this.formId)

      // UPDATE EXISITING FORM
      this._formService.UpdateDigitalFormCategory(this.formId, this.FormcatId).subscribe(res=>{
        if(res>0){
          this._notification.success('Saved','Update Form Category Successfully')
          this.GetDigitalFormDetails();
        }else{
          this._notification.error('Failed','Failed to update Form Category')
        }
      })
    }
    
  }

  // DeleteQuestion(formId:number, QuestionId:number){
  //     this._formService.DeleteSelectedQuestion(formId, QuestionId).subscribe(res=>{
  //       if(res>0){
  //         this._notification.success('Saved','Delete Question Successfully')
  //         this.GetDigitalFormDetails();
  //       }else{
  //         this._notification.error('Failed','Failed to delete Question')
  //       }
  //     })
  // }

  // DeleteSection(formId:number, catId:number, parentId:number){
  //   this._formService.DeleteSelectedCategory(formId,catId,parentId).subscribe(res=>{
  //     if(res>0){
  //       this._notification.success('Saved','Delete  Successfully')
  //       this.GetDigitalFormDetails();
  //     }else{
  //       this._notification.error('Failed','Failed to delete ')
  //     }
  //   })
  // }
  FormCustomersSelect(){

    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.customerId;
    this._formService.UpdateCustomerForForm(info).subscribe(res=>{
      if(res){
        this.loadJobsitesForCustomer();
        this.loadFamiliesForCustomer();
        //this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Failed to Update Form ')
      }
    })
  }

  loadJobsitesForCustomer() {
    if (this.customerId == null)
        return;
    this.JobsiteId = null;
    this.jobsiteList = null;
    var params: JobsiteSelectionFilter = {
        Customers: this.customerId,
      }
    this._formService.GetjobsitesAvailable(params).subscribe(r => {
        if (r) {
          //console.log("r", r)
            this.jobsiteList = r;
            if(this.formId>0){
              this.JobsiteId = this.form.jobsiteId;
            }
        }
      });
     // this.LoadAllImplementTypesForCustomers();
}

  FormJobsitesSelect(){

    var info = new UpdateCustomerVM();
  info.formId=this.formId;
  info.selectedList=this.JobsiteId;
  this._formService.UpdateJobsiteForForm(info).subscribe(res=>{
    if(res){
      //this._notification.success('Saved','Update Form Successfully')
    }else{
      this._notification.error('Failed','Failed to Update Form ')
    }
  })
}
  UpdateFormName(){
    this._formService.UpdateFormName(this.formId,this.formName,1).subscribe(res=>{
      if(res>0){
        this._notification.success('Saved','Saved Form Name Successfully')
      }else{
        this._notification.error('Failed','Failed to update Form Name')
      }
    })
  }

  toggleEmailOnComplete(){
    this._formService.UpdateEmailOnComplete(this.formId).subscribe(res=>{
      if(res>0)
      this._notification.success('Updated','Update Email on Complete')
    else
      this._notification.error('Failed','Failed to update Email on Complete')
    
    })
  }
  toggleStartByInspector(){
    this._formService.UpdateStartByInspectoor(this.formId).subscribe(res=>{
      if(res>0)
      {
        this.startbySupervisor = false;
        this._notification.success('Updated','Update Start by Inspector');
      }
    else
      this._notification.error('Failed','Failed to update Start by Inspector');
    
    })
  }

  toggleStartBySupervisor(){
    this._formService.UpdateStartBySupervisor(this.formId).subscribe(res=>{
      if(res>0)
      {
        this.startbyInspector = false;
        this._notification.success('Updated','Update Start by Supervisor');
      }
    else
      this._notification.error('Failed','Failed to update Start by Supervisor');
    
    })
  }
  
  toggleFECRForm(){
    //console.log("clecik Fecr", this.FECRForm)

    if(this.FECRForm==true){
      this.showFECRTypes=true;
    }else{
      this.showFECRTypes=false;
    }
    this._formService.UpdateFECRForm(this.formId).subscribe(res=>{
      if(res>0)
      this._notification.success('Updated','Update the Form')
    else
      this._notification.error('Failed','Failed to update the Form')
    
    })
  }

  SelectFECRInspectionType(){
    this._formService.UpdateFECRFromType(this.formId, this.fecrInspectionTypeId).subscribe(res=>{
      if(res>0){
        this._notification.success('Saved','Update Component Rebuild Type')
      }else{
        this._notification.error('Failed','Failed to update Component Rebuild Type')
      }
    })
  }
  OpenAddCategory( ) {
    const addCategoeynDialog = this._dialog.open(AddFormcategoryComponent, {
      data: {
        isSection:false,
        isCategoery:true,
        formId:this.formId,
        isEdit: true       
      }
    });
    addCategoeynDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }

  OpenAddSection(parentCatId: number, formId:number) {
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      data: {
        parentCatId: parentCatId,
        isSection:true,
        formId:formId,
        isEdit: true 
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }

  OpenAddQuestion(sectionId: number, formId:number) {
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      width: '900px',
          height:'800px',
      data: {
        sectionId: sectionId,
        isSection:false,
        isQuestion:true,
        formId:formId,
        QuestionTypes:this.questionTypes,
        customerId:this.customerId,
        modelId:this.modelId,
        isEdit: false
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }
  QuestionDetails:AddQuestionVM;
  OpenEditQuestion( formId:number,QuestionId: number) {

    this._formService.GetQuestionDetails(QuestionId).subscribe(res=>{
      this.QuestionDetails = res;

      const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
        width: '900px',
            height:'800px',
        data: {
          QuestionId: QuestionId,
          isSection:false,
          isQuestion:false,
          isQuestionEdit:true,
          formId:formId,
          QuestionTypes:this.questionTypes,
          QuestionDetails:this.QuestionDetails,
          customerId:this.customerId,
          modelId:this.modelId,
          isEditQ:1,
          isEdit: true
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        if (details ==true) {
          this.GetDigitalFormDetails();
        }
      });
    });
    
  }
  OpenEditCategory(formId:number,catId:number, isParent:boolean,Name:string){
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      
      data: {
        sectionId: catId,
        isSection:false,
        isQuestion:false,
        isCategoeryEdit:true,
        formId:formId,
        isParent:isParent,
        Name:Name,
        isUpdateCat:1,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }
  OrderUP_C(order:number, formId:number){
    this._formService.OrderUp_Categories(formId,order).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderDown_C(order:number, formId:number){
    this._formService.OrderDown_Categories(formId,order).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderUP_S(order:number, formId:number,parentId:number){
    this._formService.OrderUp_Section(formId,order,parentId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderDown_S(order:number, formId:number,parentId:number){
    this._formService.OrderDown_Section(formId,order,parentId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderUP_Q(order:number, formId:number,sectionId:number){
    this._formService.OrderUp_Q(formId,order,sectionId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }

  OrderDown_Q(order:number, formId:number,sectionId:number){
    this._formService.OrderDown_Q(formId,order,sectionId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  // toggleForm(questionId:number, Active:boolean){
  //     this._formService.TogglelFormQuestion(questionId,Active,1).subscribe(res=>{
  //       this.GetDigitalFormDetails();
  //     })
  // }


  // toggleFormSection(catId:number, Active:boolean){
  //   this._formService.TogglelFormCategory(catId,Active,1).subscribe(res=>{
  //     this.GetDigitalFormDetails();
  //   })
  // }
  toggleFormSection(catId:number, Active:boolean){

    //show dialog
const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
// width: '700px',
// height:'250px',
data: {
 open: true,
 isCopied:false,
 isParent:false,
 isDelete:true,
 value:"Section/Category",
}
});
addSectionDialog.afterClosed().subscribe(details => {
if (details>0) {
 this._formService.TogglelFormCategory(catId,Active,0).subscribe(res=>{
   this.GetDigitalFormDetails();
 })
}

});
 
}
toggleForm(questionId:number, Active:boolean){
  //show dialog
const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
// width: '700px',
// height:'250px',
data: {
  open: true,
  isCopied:false,
  isParent:false,
  isDelete:true,
  value:"Question",
}
});
addSectionDialog.afterClosed().subscribe(details => {
if (details>0) {
  this._formService.TogglelFormQuestion(questionId,Active,0).subscribe(res=>{
    this.GetDigitalFormDetails();
  })
}

});
   
}
  
   loadModelList() {
     //console.log("selectedfamilies", this.familyId)
    this.modelList = null
    
    if(this.familyId.length>0){
      this.showModelList=true;
      this._formService.GetModelsAvailable(this.familyId).subscribe(r => {
        if (r) {
          this.modelList = r;
        }
      });
    }else{
      this.showModelList=false;
      
    }
    

  }

  SelectModels(){
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.modelId;
    this._formService.UpdateFormModels(info).subscribe(res=>{
      if(res){
        //this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Need to have at leaset one model selected')
      }
    })
  }
  ImpTemplateId:number[];

  LoadImplementTemplateList(){
    let params =  new ImplementLoadVM();
     params.customer=this.customerId==undefined?[]:this.customerId;
     params.models=this.modelId==undefined?[]:this.modelId;
     //console.log("list", params)
      this._formService.LoadImplmentTemplates(params).subscribe(res=>{
        this.ImplementTemplateList = res;
        if(this.form!=null){
          this.ImpTemplateId = this.form.FormLinkedTemplateId;

        }
      });
  }
  SelectImplement(){
    //let array_ = [];
    // array_.push(this.ImpTemplateId);
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.ImpTemplateId;
    this._formService.UpdateFormImplementTemplate(info).subscribe(res=>{
      if(res){
        //this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Failed to Update Implement Link. ')
      }
    })
  }
  // OpenModifyImplement(){
  //   this._appService.getUndercarriageUrl().subscribe(result => {
  //     if (result != null && result != '')
  //         window.open(result+'setup/existing-implement-new/' + this.ImpTemplateId, '_blank');
  //  //this._sanitizer.bypassSecurityTrustUrl(result+'setup/existing-implement-new/' + this.ImpTemplateId); //result+'digitalForm/search';
  //   });
  // }

  // CreateNewForm(){
  //  this._route.navigate
  // }
}
